/**
 * @fileoverview App - Main application component with routing
 * @module App
 *
 * @description
 * Root component that renders the application routing system with AppRoutes.
 * Handles all route management with lazy loading, authentication, and RBAC.
 */

import { AppRoutes } from '@/routes/AppRoutes';

/**
 * App - Main application component
 *
 * @description
 * Root component that renders the application routing system.
 * Uses AppRoutes for all route management with lazy loading and authentication.
 *
 * @component
 * @returns {JSX.Element} Application routes
 *
 * @example
 * ```tsx
 * // In src/main.tsx
 * import App from './App';
 *
 * root.render(<App />);
 * ```
 */
export default function App(): JSX.Element {
  return <AppRoutes />;
}
